
const prefix = 'FINANCES_';

export const financesConstants = {
    UPDATE_FINANCES: prefix + 'UPDATE_FINANCES',
    UPDATE_FINANCES_RESPONSE: prefix + 'UPDATE_FINANCES_RESPONSE'
};
